import type { ReactElement } from 'react'
import { BuiltInListMark } from 'app/components/lists/BuiltInListMark'
import type { ListKindName } from 'app/types/list-kind'
import { LIST_KINDS } from 'lib/listKinds'

/** Under a list's title: its kind and what that means. A smart list is signed with the brand tile; the others stay quiet. */
export function ListKindLine({ kind }: { kind: ListKindName }): ReactElement {
  const { Icon, label, blurb } = LIST_KINDS[kind]
  if (kind === `builtIn`)
    return (
      <p className="mt-1.5 flex flex-wrap items-center gap-x-1.5 gap-y-1 text-body-sm text-default">
        {/* The label beside it already says what the tile would. */}
        <span aria-hidden="true">
          <BuiltInListMark className="size-4.5 rounded-sm">
            <Icon weight="fill" aria-hidden="true" />
          </BuiltInListMark>
        </span>
        <span className="text-label-sm text-(--chip-blue-ink)">{label}</span>
        <span aria-hidden="true" className="text-minimal">
          ·
        </span>
        <span>{blurb}</span>
      </p>
    )
  return (
    <p className="mt-1 flex items-center gap-1.5 text-body-sm text-subtle">
      <Icon size={14} weight="bold" aria-hidden="true" className="shrink-0" />
      <span>{label}</span>
      <span aria-hidden="true">·</span>
      <span>{blurb}</span>
    </p>
  )
}
